import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormularioComponent } from '../../shared/formulario/formulario.component';
import { GlobalState } from '../../services/global-state';
import { LlamanosApiService } from '../../services/api-llamanos.service';
import { ExternalApisService } from '../../services/external-apis.service';
import { getCategorias } from '../../utils/categorias';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-llamanos',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, FormularioComponent],
  templateUrl: './llamanos.component.html',
  styleUrls: ['./llamanos.component.scss'],
})
export class LlamanosComponent {
  selectedEstacion: any = null;
  selectedCategoria: any = {};
  selectedSubcategoria: any = null;
  selectedSubcategoriaKey: string | null = null;
  showFormulario: boolean = false;

  pagador: string = '';
  edsOptions: Array<{ label: string; value: number; desde: Date }> = [];
  selectedEstacionComplete: {
    label: string;
    value: number;
    desde: Date;
  } | null = null;
  categoriasOptions: Array<{ label: string; value: string }> = [];
  subcategoriasOptions: Array<{ label: string; value: string }> = [];
  private categoriasRaw: Record<string, any> = {};

  isArcoprime: boolean = false;
  pagadores: Array<{ id_pagador: string; label: string }> = [];
  selectedPagador: string | null = null;

  constructor(
    private globalState: GlobalState,
    private api: LlamanosApiService,
    private externalApis: ExternalApisService,
  ) {}

  ngOnInit(): void {
    // Only read from global state; external calls happen on app init
    this.globalState.pagador$.subscribe((p) => (this.pagador = p || ''));
    this.globalState.isArcoprime$.subscribe((v) => (this.isArcoprime = v));

    this.globalState.pagadoresActivos$.subscribe((pagadores) => {
      if (!this.isArcoprime) return;
      this.pagadores = pagadores || [];
      if (this.pagadores.length === 1) {
        this.onPagadorChange(this.pagadores[0].id_pagador);
      }
    });

    this.globalState.allEds$.subscribe((eds) => {
      if (this.isArcoprime) return;
      this.edsOptions = eds || [];
      if (this.edsOptions.length === 1) {
        this.selectedEstacion = this.edsOptions[0]?.value;
        this.selectedEstacionComplete = this.edsOptions[0];
      }
    });
    // Load categorias from api-llamanos (usando util compartido)
    this.api.getCategorias().subscribe({
      next: (data) => {
        const filteredSource = getCategorias(data);

        this.categoriasRaw = filteredSource;

        this.categoriasOptions = Object.keys(filteredSource).map((key) => ({
          label: String(key),
          value: String(key),
        }));
      },
      error: (err) => {
        console.error('Error cargando categorias en llamanos: ', err);
      },
    });
  }

  onCategoriaChange(categoriaKey: string): void {
    this.selectedCategoria = categoriaKey;
    this.selectedSubcategoria = null;
    this.selectedSubcategoriaKey = null;
    const entry = this.categoriasRaw?.[categoriaKey];
    const rawSubcats: any[] = Array.isArray(entry) ? entry : [];
    // Normalize as in mantenedor
    const normalized = rawSubcats.map((sub) => {
      const pairs = Object.entries(sub || {});
      const [subKey] = pairs.length > 0 ? pairs[0] : [''];
      return { key: subKey };
    });
    this.subcategoriasOptions = normalized.map((s) => ({
      label: String(s.key),
      value: String(s.key),
    }));
  }

  onSubcategoriaChange(subcategoriaKey: string): void {
    this.selectedSubcategoriaKey = subcategoriaKey;
    this.selectedSubcategoria = this.getSubcategoriaCompleta(subcategoriaKey);
  }

  onEstacionChange(estacionValue: number): void {
    this.selectedEstacion = estacionValue;
    this.selectedEstacionComplete =
      this.edsOptions.find((eds) => eds.value === estacionValue) || null;
  }

  onPagadorChange(idPagador: string): void {
    this.selectedPagador = idPagador;
    this.selectedEstacion = null;
    this.selectedEstacionComplete = null;
    this.edsOptions = [];
    if (!idPagador) return;
    this.globalState.pagador = idPagador;
    this.externalApis.getEdsForPagador(idPagador, false).subscribe((eds) => {
      this.edsOptions = eds || [];
      if (this.edsOptions.length === 1) {
        this.selectedEstacion = this.edsOptions[0]?.value;
        this.selectedEstacionComplete = this.edsOptions[0];
      }
    });
  }

  private getSubcategoriaCompleta(subcategoriaKey: string): any {
    const categoriaEntry = this.categoriasRaw?.[this.selectedCategoria];
    if (!Array.isArray(categoriaEntry)) return null;

    for (const sub of categoriaEntry) {
      if (sub && typeof sub === 'object') {
        const pairs = Object.entries(sub);
        if (pairs.length > 0) {
          const [key, subcategoriaData] = pairs[0];
          if (key === subcategoriaKey) {
            return {
              key: key,
              label: key,
              ...(subcategoriaData as any),
            };
          }
        }
      }
    }
    return null;
  }

  setShowFormulario(newStatus: boolean): void {
    this.showFormulario = newStatus;
  }

  finish(ncaso: string): void {
    this.showFormulario = false;
  }
}
